import React, { FC, useEffect, useState } from "react"
import styled from "styled-components"
import { SectionTransparent } from "../ui/SectionTransparent"
import { black, authGradientStart, white } from "../components/colors"
import { logoIcon as WpLogoIcon, logoName as WpLogoName, appLogoIconAlt, appLogoNameAlt, appName } from "../sportConfig"
import { Spin } from "antd"
import { useStripeSessionQuery } from "../queries"
import { Button } from "../ui/Button"
import { useNavigate } from "react-router-dom"
import { StripeCheckoutSession } from "@stripe/stripe-js"

const AuthContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  background-image: radial-gradient(${authGradientStart} 0%, ${black} 100%);
  align-items: center;
  justify-content: center;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  color: ${white};
  overflow: scroll;
  align-items: center;
  gap: 48px;
  padding-top: 72px;
  padding-bottom: 72px;
  padding-left: 36px;
  padding-right: 36px;
`

const SectionContainerTransparent = styled(SectionTransparent)`
  max-width: 720px;
  text-align: center;
  font-size: 1.3rem;
  gap: 16px;
  width: 100%;
`

const LogoText = styled.img``

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
  gap: 16px;
  & > img {
    height: 96px;
    width: auto;
  }

  & > ${LogoText} {
    height: 72px;
  }
`
export const PurchaseCompletePage: FC = () => {

  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [sessionId, setSessionId] = useState<string | null>(null)
  const [status, setStatus] = useState<string | null>(null)
  const navigate = useNavigate()

  const { data } = useStripeSessionQuery({
    sessionId: sessionId!,
    enabled: !!sessionId
  })

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const sessionId = urlParams.get('session_id')
    setSessionId(sessionId)
  }, [])

  useEffect(() => {
    if (data) {
      console.log('Stripe session data:', data)
      setIsLoading(false)
      if ((data.status === 'complete' && data.payment_status === 'paid')) {
        // Handle successful payment
        setStatus('success')
      } else {
        setStatus('failed')
      }
    }
  }, [data])

  return (
    <AuthContainer>
      <Container>
        <LogoContainer style={{ marginTop: "20px" }}>
          <img
            src={WpLogoIcon}
            alt={appLogoIconAlt}
            width={100}
            height={100}
          />
          <LogoText
            src={WpLogoName}
            alt={appLogoNameAlt}
            width={640}
            height={260}
          />
        </LogoContainer>
        <SectionContainerTransparent title={isLoading ? 'Payment in progress' : 'Purchase Completed'}>
          {isLoading && (
            <div>
              <Spin size={'large'} />
              <div style={{ paddingTop: '18px' }}>
                Waiting for the purchase to be processed...
              </div>
            </div>
          )}
          { !isLoading && status === 'success' && (
            <div>
              <h2 style={{ marginBottom: '4px' }}>Thank you for your purchase!</h2>
              <div style={{ fontSize: '16px'}}>Transaction id: {data?.id}</div>
              <p style={{ marginBottom: '5px' }}>Your payment has been successfully processed.</p>
              <p style={{ marginTop: '0' }}>You can now access all the features of {appName}.</p>
              <Button large={true} onClick={() => navigate('/')}>Go to board</Button>
            </div>
          )}
          { !isLoading && status === 'failed' && (
            <div>
              <h2 style={{ marginBottom: '4px' }}>Purchase Failed</h2>
              <p style={{ marginTop: '0' }}>Unfortunately, your purchase could not be completed.</p>
              <p>Please try again later or contact support if the issue persists.</p>
              <Button large={true} onClick={() => navigate('/')}>Go to board</Button>
            </div>
          )}
        </SectionContainerTransparent>
      </Container>
    </AuthContainer>
  )
}